// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5Shgf","contiainer":"styles_contiainer__wrQLm"};